/**
 *  DownloadAgreementModal Component
 */

import './styles.scss';

import { WithRouter, withRouter } from 'found';
import * as React from 'react';
import * as BEM from 'react-bem-helper';

import { DownloadContext } from '../../../../contexts/download';
import { IDownloadContext } from '../../../../contexts/download/types';
import { downloadTrack } from '../../../../redux/actions/download';
import Button from '../../../atoms/buttons/Button';
import CheckboxWithLabel from '../../../molecules/forms/CheckboxWithLabel';
import * as Modal from '../ModalBase';

interface IDownloadContextProps {
  downloadContext: IDownloadContext;
}

type DownloadAgreementModalProps =
  & IDownloadContextProps
  & WithRouter;

interface IOwnState {
  dontShowAgain: boolean;
}

enum ModalAction {
  Download = 'download',
}

const classes = new BEM('download-agreement-modal');

class DownloadAgreementModalBase extends React.Component<DownloadAgreementModalProps, IOwnState> {

  constructor(props) {
    super(props);
    this.state = {
      dontShowAgain: !this.props.downloadContext.agreementVisibility,
    };
  }

  onModalClose: Modal.OnCloseModalHandler = (id) => {
    this.props.downloadContext.clear();

    if (id === ModalAction.Download) {
      if (this.state.dontShowAgain) {
        this.props.downloadContext.setAgreementVisibility(false);
      }
    }
  }

  onChangeCheckbox = (dontShowAgain) => {
    this.setState({ dontShowAgain });
  }

  render() {
    const {
      downloadContext: {
        filePath: path,
        dispatch,
        track,
      },
    } = this.props;
    return (
      <Modal.Component
        actions={(
          <>
            <Modal.CancelAction label="Cancel" />
            <Modal.Action
              id={ModalAction.Download}
              Element={(
                <Button
                  onClick={() => dispatch(downloadTrack({ track: track! }))}
                  hyperLinkProps={{
                    href: path,
                  }}
                  wrapperComponent="a"
                  label="Agree and Download"
                />
              )}
            />
          </>
        )}
        position={Modal.Position.Top}
        onClose={this.onModalClose}
        {...classes()}
      >
        <Modal.Content>
          <Modal.Title>
            This download is for preview purposes only. You must purchase a license before using it in a production.
          </Modal.Title>
          <div {...classes('checkbox')}>
            <CheckboxWithLabel
              label="Don't show this again"
              name="always-agree-download"
              checked={this.state.dontShowAgain}
              onChange={this.onChangeCheckbox}
            />
          </div>
        </Modal.Content>
      </Modal.Component>
    );
  }
}

const DownloadAgreementModalWithDownloadContext: React.SFC<WithRouter> = (props) => (
  <DownloadContext.Consumer>
    {(ctx) => !!ctx.filePath ? (
      <DownloadAgreementModalBase
        downloadContext={ctx}
        {...props}
      />
    ) : null}
  </DownloadContext.Consumer>
);

export default withRouter<{}>(DownloadAgreementModalWithDownloadContext);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/modals/DownloadAgreementModal/index.tsx